<template>
  <ul class="social-list">
    <li>
      <a href="https://www.facebook.com/staydcom" target="_blank">
        <font-awesome-icon :icon="['fab', 'facebook']" />
      </a>
    </li>
    <li>
      <a href="https://www.twitter.com/staydcom" target="_blank">
        <font-awesome-icon :icon="['fab', 'twitter']" />
      </a>
    </li>
    <li>
      <a href="https://www.instagram.com/staydcom" target="_blank">
        <font-awesome-icon :icon="['fab', 'instagram']" />
      </a>
    </li>
    <!--
    <li>
      <a href="#" target="_blank">
        <font-awesome-icon :icon="['fab', 'youtube']" />
      </a>
    </li>
    -->
    <li>
      <a href="https://www.linkedin.com/company/staycom" target="_blank">
        <font-awesome-icon :icon="['fab', 'linkedin']" />
      </a>
    </li>
  </ul>
</template>

<script>
  import { library } from '@fortawesome/fontawesome-svg-core'
  import { faFacebook } from '@fortawesome/free-brands-svg-icons'
  import { faTwitter } from '@fortawesome/free-brands-svg-icons'
  import { faInstagram } from '@fortawesome/free-brands-svg-icons'
  import { faYoutube } from '@fortawesome/free-brands-svg-icons'
  import { faLinkedin } from '@fortawesome/free-brands-svg-icons'

  library.add(faFacebook)
  library.add(faTwitter)
  library.add(faInstagram)
  library.add(faYoutube)
  library.add(faLinkedin)

  export default {
    name: 'SocialIconList',
  }

</script>

<style scoped>
  .social-list{
    padding:0;
    list-style:none;
  }
  .social-list li{
    display:inline-block;
    margin-right:15px;
  }
  .social-list li a{
    color:#fff;
    font-size:20px;
  }
  .social-list li a:hover{
    opacity:0.8;
  }
</style>